export class YearMonth {
  readonly year: number;
  readonly month: number;

  constructor(year: number, month: number) {
    this.year = year;
    this.month = month;
  }
}
